 
namespace TabAurous.Retail {
    import fld = ExchangeItemsBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ExchangeItemsBOMEditor extends _Ext.BOMGridEditor<ExchangeItemsBOMRow> { 
        protected getDialogType() { return ExchangeItemsBOMDialog; }
        protected getLocalTextPrefix() { return ExchangeItemsBOMRow.localTextPrefix; }
     

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ExchangeItemsDialog).CalculateTotals();
                }
            })

        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }
         

        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            var grid = OMS.RawMaterialMasterSelectGrid; 
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var Exchangedetails = [];
                        var ratelistId = this.RateListId;
                        //alert(selectedItems2.length);
                        selectedItems2.forEach(function (value) {
                            var prdid = value.ProductId;
                            //alert(prdid); 
                            var Pieces = 0;
                            var Weight = 0.01;
                            var Rate = 0;
                            var Amount = 0;
                            var SubTypeID = value.SubCategoryId;
                            var Purity = value.Purity;
                            if (SubTypeID == 301 || SubTypeID == 302 || SubTypeID == 303 || SubTypeID == 304) {
                                var MetalRate = GetItemRateHelper.GetGetMetalRate(SubTypeID);
                                Rate = MetalRate;
                                Amount = Rate * Weight * Purity;

                            }
                            else {
                                var ItemRate = GetItemRateHelper.GetSalesRate(value.AttributeId, ratelistId);
                                Rate = ItemRate;
                                Pieces = 1;
                                if (value.CalcOnId == 3) {
                                    Amount = Rate * Pieces
                                }
                                else {
                                    Amount = Rate * Weight;
                                }
                            }


                            var ExchangeBom: ExchangeItemsBOMRow = {
                                BOMProductId: prdid,

                                ProductCode: value.ProductCode,
                                BOMAttributeId: value.AttributeId,
                                Attribute: value.Attribute,
                                ItemType: value.ItemType,
                                ItemTypeId: value.ItemTypeId,


                                StoneColorId: value.StoneColorId,
                                MetalColorId: value.MetalColorId,
                                KaratId: value.KaratId,

                                BomRate: Rate,
                                Pieces: 1,
                                Weight: 0.1,
                                CalcOnId: value.CalcOnId,
                                ShapeId: value.ShapeId,
                                QualityId: value.QualityId,

                                //StdPurity: Purity,
                                BomAmount: Amount 
                            };
                            Exchangedetails.push(ExchangeBom);

                        });


                        for (let ExchangeDetail of Exchangedetails) {
                            ExchangeDetail[this.getIdProperty()] = "`" + this.nextId++; 
                            this.view.addItem(ExchangeDetail); 
                        } 
                    } 
                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        } 
    }
}